'use client';
import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function ScrollRestore(): null {
  const pathname = usePathname();

  useEffect(() => {
    if (window && document) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
